import React from 'react';
import { Check } from 'lucide-react';

const OrderConfirmationPage = ({ orderData, onBackToHome }) => {
  const { order_id, total, payment_info, customer_email } = orderData;

  return (
    <div className="confirmation-page" style={{
      minHeight: '100vh',
      backgroundColor: '#000',
      color: '#fff',
      padding: '40px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div className="confirmation-content" style={{
        maxWidth: '700px',
        width: '100%'
      }}>
        <div style={{
          border: '2px solid #8B0000',
          padding: '40px',
          background: '#0a0a0a',
          textAlign: 'center'
        }}>
          {/* Success Icon */}
          <div style={{
            width: '80px',
            height: '80px',
            background: '#8B0000',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 30px'
          }}>
            <Check size={50} color="#fff" />
          </div>

          <h1 style={{
            fontSize: '2.5rem',
            color: '#8B0000',
            marginBottom: '20px'
          }}>
            ORDER CONFIRMED!
          </h1>

          <p style={{
            fontSize: '18px',
            marginBottom: '30px',
            lineHeight: '1.6'
          }}>
            Thank you for your order! A confirmation email has been sent to <strong style={{ color: '#8B0000' }}>{customer_email}</strong>
          </p>

          {/* Order Number */}
          <div style={{
            background: '#000',
            border: '2px solid #8B0000',
            padding: '20px',
            marginBottom: '30px'
          }}>
            <p style={{ fontSize: '16px', marginBottom: '10px', color: '#999' }}>
              Your Order Number:
            </p>
            <p style={{
              fontSize: '28px',
              fontWeight: 'bold',
              color: '#8B0000',
              marginBottom: '0'
            }}>
              {order_id}
            </p>
          </div>

          {/* Payment Instructions */}
          <div style={{
            background: '#1a0000',
            border: '2px solid #8B0000',
            padding: '25px',
            marginBottom: '30px',
            textAlign: 'left'
          }}>
            <h2 style={{
              fontSize: '20px',
              color: '#8B0000',
              marginBottom: '15px',
              textAlign: 'center'
            }}>
              Next Steps - Complete Your Payment
            </h2>

            <p style={{ fontSize: '16px', marginBottom: '15px' }}>
              Send <strong style={{ color: '#8B0000' }}>${total.toFixed(2)}</strong> to:
            </p>

            <div style={{ marginBottom: '20px' }}>
              <p style={{ fontSize: '18px', marginBottom: '8px' }}>
                <strong>Zelle:</strong> <span style={{ color: '#8B0000' }}>770-296-7715</span>
              </p>
              <p style={{ fontSize: '18px' }}>
                <strong>CashApp:</strong> <span style={{ color: '#8B0000' }}>$taniskn</span>
              </p>
            </div>

            <div style={{
              background: '#000',
              border: '2px solid #ff6b6b',
              padding: '15px',
              marginBottom: '15px'
            }}>
              <p style={{
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#ff6b6b',
                marginBottom: '10px',
                textAlign: 'center'
              }}>
                ⚠️ IMPORTANT: Include this in your payment note:
              </p>
              <p style={{
                fontSize: '16px',
                color: '#8B0000',
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: '0'
              }}>
                {payment_info.payment_note}
              </p>
            </div>

            <p style={{ fontSize: '14px', color: '#999', lineHeight: '1.6', marginBottom: '0' }}>
              Once you send the payment, we'll process your order and send you shipping updates via email.
            </p>
          </div>

          {/* Back Button */}
          <button
            onClick={onBackToHome}
            style={{
              background: '#8B0000',
              color: '#fff',
              border: 'none',
              padding: '15px 40px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              width: '100%',
              transition: 'all 0.3s'
            }}
          >
            BACK TO HOME
          </button>

          <p style={{
            fontSize: '14px',
            color: '#666',
            marginTop: '20px',
            marginBottom: '0'
          }}>
            Questions? Email us at <a href="mailto:gored.offc@gmail.com" style={{ color: '#8B0000' }}>gored.offc@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationPage;
